/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  shoppingMall.ts
 * @Package :
 * @author:飞算科技
 * @date:   2022/1/19 11:27
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 飞算科技
 * 注意：本内容仅限于飞算数智科技（深圳）有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import {GetPreOrderInfoParamsDto, PreOrderListDto} from "@/api/buyCar";
import {GetPreReturnOrderParamsDto, PreRtnOrderInfoDto} from "@/api/shopOrder";
interface PreReturnOrderParamsDto {
  orderId?:string
  storeId?:string
  partnerCOmpanyId?:string
  buyCompanyId?:string
  returnOrderDtl?:[]
}
const shoppingMall = {
  state: {

    preOrderParams: {}, // 获取预提交订单信息入参数据类型
    preReturnOrderParams: {}, // 获取预提交订单信息入参数据类型
    orderDtl: {}, // 订货套餐清单
    returnOrderDtl: {}, // 退货套餐清单
    returnOrderList: [] // 退单列表
  },
  mutations: {
    SET_PRE_ORDER_PARAMS: (state: any, preOrderParams: GetPreOrderInfoParamsDto) => {
      state.preOrderParams = preOrderParams
    },
    SET_PRE_RETURN_ORDER_PARAMS: (state: any, preReturnOrderParams: PreReturnOrderParamsDto) => {
      state.preReturnOrderParams = preReturnOrderParams
    },
    SET_ORDER_DTL_LIST: (state: any, orderDtl: PreOrderListDto) => {
      state.orderDtl = orderDtl
    },
    SET_RETURN_ORDER_DTL: (state: any, returnOrderDtl: PreRtnOrderInfoDto) => {
      state.returnOrderDtl = returnOrderDtl
    },
    SET_RETURN_ORDER_LIST: (state: any, returnOrderList) => {
      state.returnOrderList = returnOrderList
    }
  },
  actions: {
    setPreOrderParams({ commit }: any, preOrderParams: GetPreOrderInfoParamsDto) {
      commit("SET_PRE_ORDER_PARAMS", preOrderParams);
    },
    setPreReturnOrderParams({ commit }: any, preReturnOrderParams: PreReturnOrderParamsDto) {
      commit("SET_PRE_RETURN_ORDER_PARAMS", preReturnOrderParams);
    },
    setOrderDtlList({ commit }: any, orderDtl: PreOrderListDto) {
      commit("SET_ORDER_DTL_LIST", orderDtl);
    },
    setReturnOrderDtlList({ commit }: any, returnOrderDtl: PreRtnOrderInfoDto) {
      commit("SET_RETURN_ORDER_DTL", returnOrderDtl);
    },
    setReturnOrderList({ commit }: any, returnOrderList) {
      commit("SET_RETURN_ORDER_LIST", returnOrderList);
    },
    /* 清除缓存 */
    clearMallStore({ commit }: any) {
      commit("SET_PRE_ORDER_PARAMS", {});
      commit("SET_PRE_RETURN_ORDER_PARAMS", {});
      commit("SET_ORDER_DTL_LIST", {});
      commit("SET_RETURN_ORDER_DTL", {});
      commit("SET_RETURN_ORDER_LIST", {});
    },
  },
};

export default shoppingMall;
